"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent = /** @class */ (function () {
    function AbstractComponent(selector) {
        if (selector === void 0) { selector = ''; }
        if (selector !== '') {
            this.setSelector(selector);
        }
    }
    AbstractComponent.prototype.getSelector = function () {
        return this.SELECTOR;
    };
    AbstractComponent.prototype.setSelector = function (selector) {
        this.SELECTOR = selector;
        this.selectElement();
    };
    AbstractComponent.prototype.selectElement = function () {
        this.element = document.querySelector("[".concat(this.SELECTOR, "]"));
    };
    AbstractComponent.prototype.setElement = function (element) {
        this.element = element;
    };
    AbstractComponent.prototype.getElement = function () {
        var _a;
        return (_a = this.element) !== null && _a !== void 0 ? _a : null;
    };
    AbstractComponent.prototype.getChildElement = function (selector) {
        var _a;
        return (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelector(selector);
    };
    AbstractComponent.prototype.getChildElements = function (selector) {
        var _a;
        return (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector);
    };
    return AbstractComponent;
}());
exports.default = AbstractComponent;
